import { moeda, pct } from '../components/format'

export const dataBR = (iso) => (iso ? new Date(`${iso}T00:00:00`).toLocaleDateString('pt-BR') : '')

// Converte listas digitadas como "300; 450,50; 0" em ["300", "450.50", "0"].
export const listaValores = (texto) =>
  texto
    .split(/[;\n]/)
    .map((s) => s.trim().replace(/\./g, '').replace(',', '.'))
    .filter(Boolean)

export function Campo({ rotulo, children }) {
  return (
    <label>
      {rotulo}
      {children}
    </label>
  )
}

export function Cards({ itens }) {
  return (
    <div className="cards">
      {itens.map(([rotulo, valor, detalhe]) => (
        <div className="card" key={rotulo}>
          <span>{rotulo}</span>
          <strong>{valor}</strong>
          {detalhe && <small>{detalhe}</small>}
        </div>
      ))}
    </div>
  )
}

export function Recibo({ titulo, resultado }) {
  return (
    <div className="holerite">
      <h3>{titulo}</h3>
      <table>
        <thead>
          <tr><th>Cód.</th><th>Descrição</th><th>Ref.</th><th className="num">Proventos</th><th className="num">Descontos</th></tr>
        </thead>
        <tbody>
          {resultado.rubricas.map((r, i) => (
            <tr key={i}>
              <td>{r.codigo}</td>
              <td>{r.descricao}</td>
              <td>{r.referencia}</td>
              <td className="num">{r.tipo === 'PROVENTO' ? moeda(r.valor) : ''}</td>
              <td className="num">{r.tipo === 'DESCONTO' ? moeda(r.valor) : ''}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr><td colSpan="3">Totais</td><td className="num">{moeda(resultado.total_proventos)}</td><td className="num">{moeda(resultado.total_descontos)}</td></tr>
          <tr><td colSpan="3"><strong>Líquido</strong></td><td colSpan="2" className="num"><strong>{moeda(resultado.liquido)}</strong></td></tr>
        </tfoot>
      </table>
      <p className="fundamento">
        Base INSS {moeda(resultado.base_inss)} · Base IRRF {moeda(resultado.base_irrf)} ({resultado.metodo_deducao_irrf === 'SIMPLIFICADO' ? 'desconto simplificado' : 'deduções legais'}) · Base FGTS {moeda(resultado.base_fgts)} · IRRF pela tabela de {resultado.competencia_irrf} · Parâmetros {resultado.parametros_versao}
      </p>
      <details>
        <summary>Encargos patronais e memória de cálculo</summary>
        <ul>
          {(resultado.encargos_patronais || []).map((e) => (
            <li key={e.encargo}>{e.encargo}: {pct(e.aliquota, 4)} × {moeda(e.base)} = {moeda(e.valor)}</li>
          ))}
        </ul>
        <ul className="memoria">
          {resultado.memoria_calculo.map((m, i) => <li key={i}>{m}</li>)}
        </ul>
      </details>
    </div>
  )
}

export function Gravado({ registroId }) {
  return registroId ? <div className="aviso aviso-ok">Cálculo gravado (registro {registroId}).</div> : null
}
